import React, { Component } from 'react';

import Splash from './Splash.js';
import NoMatch from './NoMatch.js';
import CustomerOptions from './CustomerOptions.js';
import RedeemReward from './RedeemReward.js';
import AddPayment from './AddPayment.js';
import InvalidQRCode from './InvalidQRCode.js';
import CustomerPhoneNumber from './CustomerPhoneNumber.js';
import InvalidSession from './InvalidSession.js';
import MissingSignature from './MissingSignature.js';
import { Route, Switch } from 'react-router-dom'
import {View} from '../UIElements/All.js';

var classMap = {Splash, CustomerOptions};

export function componentWithOptions(name, appManager, options)
{
  var ThisClass = classMap[name];

  return (
    <ThisClass
      key={name}
      options={options}
      appManager={appManager}
    />
  )
}

    // <NavBar />
export const routes = (
  <View style={{minHeight:'100vh', flex:1, alignSelf:'stretch'}}>
    <Switch>
      <Route exact path="/" component={Splash} />
      <Route path="/customerOptions" component={CustomerOptions} />
      <Route path="/redeemReward" component={RedeemReward} />
      <Route path="/addPayment" component={AddPayment} />
      <Route path="/invalidQRCode" component={InvalidQRCode} />
      <Route path="/error" component={InvalidQRCode} />
      <Route path="/CustomerPhoneNumber" component={CustomerPhoneNumber} />
      <Route path="/invalidSession" component={InvalidSession} />
      <Route path="/missingSignature" component={MissingSignature} />
      <Route component={NoMatch} />
    </Switch>
  </View>
)